import React from 'react';

import {Helmet} from 'react-helmet';
import {createUseStyles} from 'react-jss';

const useChildrenEducationPageStyles = createUseStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: 32
    },
    date: {
        fontFamily: '\'Habibi\', serif',
        fontSize: 12,
        lineHeight: '18px',
        marginBottom: 8,
        marginTop: 25,
        "@media (min-width: 300px) and (min-height: 300px)": {
            fontSize: "calc(11.25px + 0.25vmin)",
            marginTop: "calc(15.625px + 3.125vmin)",
        },
        "@media (min-width: 1100px) and (min-height: 1100px)": {
            fontSize: 14,
            marginTop: "50"
        }
    },
    title: {
        alignSelf: 'stretch',
        fontFamily: '\'Spectral SC\', serif',
        marginTop: 0,
        backgroundColor: "#F5F5F5",
        paddingTop: 16,
        paddingBottom: 16,
        fontSize: 24,
        lineHeight: 1.448,
        fontWeight: 'normal',
        textAlign: 'center',
        marginBottom: 10,
        "@media (min-width: 300px) and (min-height: 300px)": {
            fontSize: "calc(11.25px + 4.25vmin)",
            paddingTop: "calc(10px + 2vmin)",
            paddingBottom: "calc(10px + 2vmin)"
        },
        "@media (min-width: 1100px) and (min-height: 1100px)": {
            fontSize: 58,
            paddingTop: 32,
            paddingBottom: 32,
        }
    },
    content: {
        fontFamily: "'Habibi', serif",
        lineHeight: 29 / 18,
        fontSize: 14,
        color: "#00070F",
        maxWidth: "55ch",
        margin: "auto",
        paddingLeft: 8,
        paddingRight: 8,
        "@media (min-width: 300px) and (min-height: 300px)": {
            fontSize: "calc(12.5px + 0.5vmin)",
            paddingLeft: "calc(5px + 1vmin)",
            paddingRight: "calc(5px + 1vmin)"
        },
        "@media (min-width: 1100px) and (min-height: 1100px)": {
            fontSize: 18,
            paddingLeft: "calc(5px + 1vmin)",
            paddingRight: "calc(5px + 1vmin)"
        },
        "& p": {
            marginBottom: 24,
            marginTop: 24
        },
        "& a": {
            fontFamily: "inherit",
            color: "#002247 !important",
        }
    }
});

export default (props) => {
    const classes = useChildrenEducationPageStyles();

    return (
        <>
            <Helmet>
                <title>Children's Education - Cornerstone Community Church</title>
            </Helmet>
            <div className={classes.container}>
                <h1 className={classes.title}>Children's Education</h1>
                <div className={classes.content}>
                    <p>Our approach to children's education is one that combines inter-generational connections with set times for age-specific instruction. Through our small group ministry, children spend time in a setting with adults who have the opportunity to model the faith before them. Our adult Sunday School classes are open to anyone who has reached the age of twelve, which creates opportunities for inter-generational discipleship.</p>
                    <p>However, we also recognize the need to give children and youth opportunities to learn among their peers with age-specific instruction. Our Sunday School begins in the nursery, where children at the youngest ages begin to learn how to think about God. At age three, children move out of the nursery for Sunday School and into the 3-4-year-old class, which has the privilege of gaining an overview of the whole Bible, along with catechism questions that help children learn Christian doctrines. The 5-6-year-old class then focuses on the connections between the Old and New Testaments in terms of promise and fulfillment, along with ongoing learning from the catechism. The 7-11-year-old class then takes these children through the Bible again, but at a deeper level.</p>
                    <p>On Sunday nights, our children have opportunities to review their Sunday morning lessons, learn and sing songs together, and talk about the mission Christ has given us to take the gospel to all nations of the world. Youth from ages 12-18 also have an opportunity to study the Bible together as a group on Sunday nights, as well as during planned youth retreats.</p>
                </div>
            </div>
        </>
    );
};